import { render, staticRenderFns } from "./DeleteResource.vue?vue&type=template&id=20065cde&scoped=true&"
import script from "./DeleteResource.vue?vue&type=script&lang=js&"
export * from "./DeleteResource.vue?vue&type=script&lang=js&"
import style0 from "./DeleteResource.vue?vue&type=style&index=0&id=20065cde&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20065cde",
  null
  
)

export default component.exports